import React, { useEffect, useContext } from 'react';
import {
  BrowserRouter as Router,
  Route, Switch, Redirect, RouteProps
} from 'react-router-dom';
import { SettingsProvider } from 'hooks/SettingsContext';
import { receiveCustomersImportQueueTaskUpdate } from 'redux/actions/customers';
import { receiveMarketingSegmentQuoteQueueTaskUpdate } from 'redux/actions/quote';
import Home from 'pages/home';
import Account from 'pages/account';
import MyPromotions from 'pages/promotions';
import MyLibrary from 'pages/library';
import PromoLibrary from 'pages/browsePromo/PromoLibrary';
import BrandPromotions from 'pages/browsePromo/BrandPromotions';
import PromoDetails from 'pages/browsePromo/PromoDetails';
import StoreProducts from 'pages/catalog/storeProducts';
import BrowseBrand from 'pages/catalog/browseBrand';
import BrowseProducts from 'pages/catalog/browseProducts';
import RequestSKU from 'pages/catalog/requestSKU';
import AutomaticPromotion from 'pages/promotions/AutomaticPromotions/AutomaticPromotion';
import EditStoreProduct from 'pages/catalog/editStoreProduct';
import Categories from 'pages/catalog/categories';
import OrdersList from 'pages/orders/OrdersList';
import OrdersMDI from 'pages/orders/OrdersMDI';
import OrdersDrDauer from 'pages/orders/OrdersDrDauer';
import OrderRefund from 'pages/orders/OrderRefund';
import StylesPalette from 'pages/core_configs/StylesPalette/StylesPalette';
import BookNowButtonConfig from 'pages/core_configs/BookNowButtonConfig';
import RequestAppointmentButton from 'pages/core_configs/RequestAppointmentButton';
import SurveyQuestion from 'pages/core_configs/SurveyQuestion';
import ConfigurationsSummary from 'pages/core_configs/ConfigurationsSummary';
import Socials from 'pages/core_configs/Socials';
import Contacts from 'pages/core_configs/Contacts';
import CouponManager from 'pages/promotions/CouponManager/CouponManager';
import CreateCouponRule from 'pages/promotions/CouponManager/CreateCouponRule';
import CreateCouponRuleAdvanced from 'pages/promotions/CouponManager/CreateCouponRuleAdvanced';
// import BluePay from 'pages/core_configs/BluePay';
import DNSSettings from 'pages/core_configs/DNSSettings/DNSSettings';
import StorePickupLocations from 'pages/core_configs/StorePickUpLocations';
import NotificationConfigs from 'pages/core_configs/NotificationConfigs';
import RewardConfigs from 'pages/core_configs/RewardConfigs/RewardConfigs';
import ReviewConf from 'pages/core_configs/ReviewConf';
import CompareConf from 'pages/core_configs/CompareConf';
import ShippingConf from 'pages/core_configs/ShippingConf';
import WishlistConf from 'pages/core_configs/WishlistConf';
import AppointmentFormBlock from 'pages/core_configs/HomepageConfigurations/AppointmentFormBlock';
import InstagramBlock from 'pages/core_configs/HomepageConfigurations/InstagramBlock';
import RewardBlock from 'pages/core_configs/HomepageConfigurations/RewardBlock';
import BenefitsBlock from 'pages/core_configs/HomepageConfigurations/BenefitsBlock';
import Testimonials from 'pages/core_configs/HomepageConfigurations/Testimonials/Testimonials';
import AdditionalHeader from 'pages/core_configs/HomepageConfigurations/AdditionalHeader';
import BlogBlock from 'pages/core_configs/HomepageConfigurations/BlogBlock';
import CTABlock from 'pages/core_configs/HomepageConfigurations/CTA/CTABlock';
import ModernCTABlock from 'pages/core_configs/HomepageConfigurations/ModernCTA/CTABlock';
import WelcomeBlock from 'pages/core_configs/HomepageConfigurations/WelcomeBlock';
import HomepageConfigurations from 'pages/core_configs/HomepageConfigurations/HomepageConfigurations';
import HomepagePromoTabs from 'pages/core_configs/HomepageConfigurations/HomepagePromoTabs';
import PremiumCTABlock from 'pages/core_configs/HomepageConfigurations/PremiumCTA/PremiumCTABlock';
import AboutUsBlock from 'pages/core_configs/AboutUsConfigurations/AboutUsBlock';
import BeforeAfterGalleryBlock from 'pages/core_configs/BeforeAfterGalleryConfigurations/BeforeAfterGalleryBlock';
import General from 'pages/core_configs/General';
import Settings from 'pages/core_configs/Settings';
import ReferralProgram from 'pages/core_configs/ReferralProgram/ReferralProgram';
import Recaptcha from 'pages/core_configs/Recaptcha';
import DefaultCustomerGroup from 'pages/core_configs/DefaultCustomerGroup';
import SubscriptionPlansSettings from 'pages/core_configs/SubscriptionPlansSettings';
import AuditLogs from 'pages/audit_logs';
import CreateStripeAccount from 'pages/stripe';
import Customer from 'pages/customers/Customer';
import CustomerForm from 'pages/customers/CustomerForm';
import CustomerRewardBalanceForm from 'pages/customers/customerRewards/CustomerRewardBalanceForm';
import Customers from 'pages/customers';
import CustomersImport from 'pages/customers/customersImport/CustomersImport';
import RequestAccessList from 'pages/customers/requestAccessList/RequestAccessList';
import Analytics from 'pages/analytics';
import Help from 'pages/help';
import EditStore from 'pages/admin/EditStore';
import MassEditProducts from 'pages/catalog/massEditProducts';
import AdminPage from 'pages/admin/AdminPage';
import DirectFulfillment from 'pages/direct_fulfilment';
import BrowseDirectFulfillmentProducts from 'pages/direct_fulfilment/browseDirectFulfillmentProducts';
import DirectFulfillmentRequestForm from 'pages/direct_fulfilment/directFulfillmentRequestForm';
import Affiliates from 'pages/affiliates-new';
import AffiliatesOld from 'pages/affiliates';
import BrowseAffiliateProducts from 'pages/affiliates/browseAffiliateProducts';
import LearnMorePage from 'pages/affiliates/LearnMorePage';
import HomepageBanner from 'pages/banner_manager/homepageBanner';
import RequestAccess from 'pages/core_configs/RequestAccess/RequestAccess';
import MassEditRequestAccess from 'pages/customers/requestAccessList/MassEditRequestAccess';
import TaxRatesOld from 'pages/core_configs/TaxRates/TaxRatesOld';
import TaxRates from 'pages/core_configs/TaxRates/TaxRates';
import AddNewTaxRate from 'pages/core_configs/TaxRates/AddNewTaxRate';
import EditTaxRate from 'pages/core_configs/TaxRates/EditTaxRate';
import StoreEmails from 'pages/core_configs/StoreEmails/StoreEmails';
import StoreConfigurationEmails from 'pages/core_configs/StoreEmails/StoreConfigurationEmails';
import TermsAndConditionsConfig from 'pages/core_configs/QuoteProConfig/TermsAndConditionsConfig';
import LoginPage from 'pages/login';
import SignUpPage from 'pages/SighUp/SignUpPage';
import Steps from 'pages/storebuild/Steps';
import AdditionalHomepageBanners from 'pages/banner_manager/additionalHomepageBanners';
import { GlobalCss, ThemeSuspense, Theme, Layout, Loading } from 'components';
import TaglinesConf from 'pages/core_configs/TaglinesConf';
import { useSelector, useDispatch } from 'react-redux';
import {isSafari, browserVersion, isChrome} from 'react-device-detect';
import { getUserProfileAPI, refreshUserTokenAPI } from 'api';
import PopUpNotifications from 'components/PopUpNotification/PopUpNotifications';
import { pathPermissions } from 'helpers/pathPermissions';
import {SocketContext} from 'contexts/SocketContext';
import { receiveQueuedTaskUpdate } from 'redux/actions/products';
import UnsupportedBrowserNotification from 'pages/unsupportedBrowserNotification';
import QuoteGroupsConfigurations from 'pages/quotes/QuoteGroups/QuoteGroupsConfigurations';
import QuoteListings from 'pages/quotes/QuoteListings/QuoteListings';
import QuoteProduct from 'pages/quotes/QuoteListings/QuoteProduct/QuoteProduct';
import BulkEditProductsGroups from 'pages/quotes/QuoteListings/BulkEditProductsGroups';
import QuoteProgression from 'pages/quotes/QuoteProgression/QuoteProgression';
import QuotingPage from 'pages/quotes/QuotingPage';
import QuotePatientPage from 'pages/quotes/QuotePatientDashboard/QuotingPatientPage';
import QuotingGroupPage from 'pages/quotes/QuotePatientDashboard/QuotingGroupPage';
import QuoteSummary from 'pages/quotes/QuoteSummary/QuoteSummary';
import QuoteWorkspace from 'pages/quotes/QuoteWorkspace/QuoteWorkspace';
import EditQuote from 'pages/quotes/QuoteWorkspace/PatientDetails/EditQuote/EditQuote';
import PatientDetails from 'pages/quotes/QuoteWorkspace/PatientDetails/PatientDetails';
import QuoteGroupPatientsSummary from 'pages/quotes/QuoteSummary/QuoteGroupPatientsSummary';
import QuoteTreatmentPlanPage from 'pages/quotes/QuoteTreatmentPlan/QuoteTreatmentPlanPage';
import AutomatedQuotes from 'pages/automatedQuotes/AutomatedQuotes';
import CustomerPreview from 'pages/automatedQuotes/CustomersList/CustomerPreview';
import AutomatedQuotesWorkspace from 'pages/automatedQuotes/QuoteWorkspace/AutomatedQuotesWorkspace';
import QuoteAutomation from 'pages/automatedQuotes/QuoteAutomation/QuoteAutomation';
import AutomatedQuoteSchedules from 'pages/automatedQuotes/Schedules/AutomatedQuoteSchedules';
import Subscriptions from 'pages/subscriptions';
import EditSubscription from 'pages/subscriptions/EditSubscription';
import Deposits from 'pages/deposits/Deposits';
import EditDeposit from 'pages/deposits/EditDeposit/EditDeposit';
import GiftCards from 'pages/gift_cards';
import CreateGiftCode from 'pages/gift_cards/giftCodes/CreateGiftCode';
import EditGiftCode from 'pages/gift_cards/giftCodes/EditGiftCode';
import Cookies from 'js-cookie';
import UnsupportedChromeNotification from 'pages/unsupportedBrowserNotification/unsuppostedChromeNotification';
import DataMappingPage from 'pages/dataMapping/DataMappingPage';
import QuoteQueuePage from 'pages/quotes/QuoteQueue/QuoteQueuePage';
import MarketingSegmentsTabs from 'pages/quotes/QuoteMarketingSegments/MarketingSegmentsTabs';
import SyncEventLogPage from 'pages/syncEventLog/SyncEventLogPage';


interface IPrivateRouteProps extends RouteProps {
  allowedStores?: Array<AllowedStoreType>,
  path: string
}

const App = () => {
  const socket = useContext(SocketContext);

  return (
    <SettingsProvider>
      <Theme>
        <GlobalCss />
        <Router>
          <ThemeSuspense>
            <Switch>
              <Route path="/login" component={LoginPage} />
              <Route path="/signup" component={SignUpPage} exact />
              <Route path="/stripe/new-account" component={CreateStripeAccount} />
              <PrivateRoute path="/data-mapping/:selectedTab" component={DataMappingPage} />
              <PrivateRoute path="/sync-event-logs" component={SyncEventLogPage} />
              <PrivateRoute path="/quoting/listings/bulk-edit" component={BulkEditProductsGroups} />
              <PrivateRoute path="/quoting/listings/edit/:sku" component={QuoteProduct} />
              <PrivateRoute path="/quoting/listings/:selectedTab" component={QuoteListings} />
              <PrivateRoute path="/quoting/profile/:id/quote-workspace/patient-activity/:quoteId/edit" component={EditQuote} />
              <PrivateRoute path="/quoting/profile/:id/quote-workspace/patient-activity" component={PatientDetails} />
              <PrivateRoute path="/quoting/profile/:id/quote-workspace/summary" component={QuoteSummary} />
              <PrivateRoute path="/quoting/profile/:id/quote-workspace/plan" component={QuoteTreatmentPlanPage} />
              <PrivateRoute path="/quoting/profile/:id/quote-workspace" component={QuoteWorkspace} />
              <PrivateRoute path="/quoting/profile/:id/" component={QuotePatientPage} />
              <PrivateRoute path="/quoting/group/:id/quote-workspace/summary" component={QuoteGroupPatientsSummary} />
              <PrivateRoute path="/quoting/group/:id/quote-workspace" component={QuoteWorkspace} />
              <PrivateRoute path="/quoting/group/:id/" component={QuotingGroupPage} />
              <PrivateRoute path="/quoting/groups" component={QuoteGroupsConfigurations} />
              <PrivateRoute path="/quoting/queue" component={QuoteQueuePage} />
              <PrivateRoute path="/quoting/marketing-segments" component={MarketingSegmentsTabs} />
              <PrivateRoute path="/quoting/progression" component={QuoteProgression} />
              <PrivateRoute path="/quoting" component={QuotingPage} />
              <PrivateRoute path="/additional-homepage-banners" component={AdditionalHomepageBanners} allowedStores={['premium_plus', 'modern_premium_plus']} />
              <PrivateRoute path="/homepage-banner" component={HomepageBanner} />
              <PrivateRoute path="/customized-promotion" component={AutomaticPromotion} />
              <PrivateRoute path="/direct-fulfillment/request-information" component={DirectFulfillmentRequestForm} />
              <PrivateRoute path="/browse-promo/:id/:tab" component={BrandPromotions} />
              <PrivateRoute path="/my-promotions/:tabName?/promo-details/:id" component={PromoDetails} />
              <PrivateRoute path="/my-promotions/:tabName?/template-details/:id" component={PromoDetails} />
              <PrivateRoute path="/browse-brand/:storeView/:id/:type" component={BrowseProducts} />
              <PrivateRoute path="/affiliates/cms/:identifier" component={LearnMorePage} />
              <PrivateRoute path="/affiliates/:id" component={BrowseAffiliateProducts} />
              <PrivateRoute path="/direct-fulfillment/:id" component={BrowseDirectFulfillmentProducts} />
              <PrivateRoute path="/browse-brand/:storeView" component={BrowseBrand} />
              <PrivateRoute path="/admin/store/:id" component={EditStore} />
              <PrivateRoute path="/affiliates" component={Affiliates} />
              <PrivateRoute path="/affiliates-old" component={AffiliatesOld} />
              <PrivateRoute path="/direct-fulfillment" component={DirectFulfillment} />
              <PrivateRoute path="/audit-logs" component={AuditLogs} />
              <PrivateRoute path="/deposits/edit/:entity_id/:order_id" component={EditDeposit} />
              <PrivateRoute path="/deposits" component={Deposits} />
              <PrivateRoute path="/automated-quotes/schedule" component={AutomatedQuoteSchedules} />
              <PrivateRoute path="/automated-quotes/:id/quote-automation" component={QuoteAutomation} />
              <PrivateRoute path="/automated-quotes/:id/customer-preview/workspace" component={AutomatedQuotesWorkspace} />
              <PrivateRoute path="/automated-quotes/:id/customer-preview" component={CustomerPreview} />
              <PrivateRoute path="/automated-quotes" component={AutomatedQuotes} />
              <PrivateRoute path="/orders/refund" component={OrderRefund} />
              <PrivateRoute path="/orders/list/mdi" component={OrdersMDI} />
              <PrivateRoute path="/orders/list/dr-dauer" component={OrdersDrDauer} />
              <PrivateRoute path="/orders/list" component={OrdersList} />
              <PrivateRoute path="/store/categories" component={Categories} />
              <PrivateRoute path="/store-products/edit/:id" component={EditStoreProduct} />
              <PrivateRoute path="/store-products/list/:selectedTab" component={StoreProducts} />
              <PrivateRoute path="/store-products/mass-edit" component={MassEditProducts} />
              <PrivateRoute path="/request-sku" component={RequestSKU} />
              <PrivateRoute path="/account" component={Account} />
              <PrivateRoute path="/promotions-library/:selectedTab?" component={PromoLibrary} />
              <PrivateRoute path="/promotions-library" component={PromoLibrary} />
              <PrivateRoute path="/my-library" component={MyLibrary} />
              <PrivateRoute path="/my-promotions/:tabName?" component={MyPromotions} />
              <PrivateRoute path="/configurations/tax-rates-old" component={TaxRatesOld} />
              <PrivateRoute path="/configurations/tax-rates" component={TaxRates} />
              <PrivateRoute path="/configurations/store-emails" component={StoreEmails} />
              <PrivateRoute path="/configurations/store-configuration-emails" component={StoreConfigurationEmails} />
              <PrivateRoute path="/configurations/add-new-tax-rate" component={AddNewTaxRate} />
              <PrivateRoute path="/configurations/edit-tax-rate" component={EditTaxRate} />
              <PrivateRoute path="/configurations/users-access" component={RequestAccess} />
              <PrivateRoute path="/configurations/styles-palette" component={StylesPalette} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'premium_lite', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/book-now-button" component={BookNowButtonConfig} />
              <PrivateRoute path="/configurations/request-appointment-button" component={RequestAppointmentButton} />
              <PrivateRoute path="/configurations/referral-program" component={ReferralProgram} />
              <PrivateRoute path="/configurations/survey-question" component={SurveyQuestion} />
              <PrivateRoute path="/configurations/summary" component={ConfigurationsSummary} />
              <PrivateRoute path="/configurations/recaptcha" component={Recaptcha} />
              <PrivateRoute path="/configurations/default-customer-group" component={DefaultCustomerGroup} />
              <PrivateRoute path="/configurations/plans" component={SubscriptionPlansSettings} />
              <PrivateRoute path="/coupon-manager/create-rule-advanced" component={CreateCouponRuleAdvanced} />
              <PrivateRoute path="/coupon-manager/create-rule" component={CreateCouponRule} />
              <PrivateRoute path="/configurations/coupon-manager" component={CouponManager} />
              <PrivateRoute path="/configurations/social-media-links" component={Socials}  allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'premium_lite', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/contacts" component={Contacts} />
              <PrivateRoute path="/configurations/dns" component={DNSSettings} />
              {/* <PrivateRoute path="/configurations/bluepay" component={BluePay} /> */}
              <PrivateRoute path="/configurations/store-pickup-locations" component={StorePickupLocations} />
              <PrivateRoute path="/configurations/rewards" component={RewardConfigs} />
              <PrivateRoute path="/configurations/notifications" component={NotificationConfigs} />
              <PrivateRoute path="/configurations/shipping" component={ShippingConf} />
              <PrivateRoute path="/configurations/general" component={General} />
              <PrivateRoute path="/configurations/comparelist" component={CompareConf} />
              <PrivateRoute path="/configurations/wishlist" component={WishlistConf} />
              <PrivateRoute path="/configurations/reviews" component={ReviewConf} />
              <PrivateRoute path="/configurations/homepage/appointment-form" component={AppointmentFormBlock} allowedStores={['premium', 'premium_plus', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/instagram-widget" component={InstagramBlock} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/reward-block" component={RewardBlock} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/benefits-block" component={BenefitsBlock} allowedStores={['premium_lite', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/additional-header" component={AdditionalHeader} allowedStores={['premium_plus', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/testimonials" component={Testimonials} allowedStores={['premium_plus', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/blog" component={BlogBlock} allowedStores={['premium_plus', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/premium-cta" component={PremiumCTABlock} allowedStores={['premium_plus', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/cta" component={CTABlock} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage/modern-cta" component={ModernCTABlock} allowedStores={['premium_lite']} />
              <PrivateRoute path="/configurations/homepage/welcome-block" component={WelcomeBlock} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/homepage" component={HomepageConfigurations} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'premium_lite', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/about-us-page" component={AboutUsBlock} allowedStores={['premium', 'premium_plus', 'premium_lite', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/before-after-gallery" component={BeforeAfterGalleryBlock} />
              <PrivateRoute path="/configurations/promos" component={HomepagePromoTabs} allowedStores={['regular', 'premium', 'skinceuticals', 'premium_plus', 'premium_lite', 'modern_premium', 'modern_premium_plus']} />
              <PrivateRoute path="/configurations/tagline" component={TaglinesConf} allowedStores={['regular', 'skinceuticals']} />
              <PrivateRoute path="/configurations/agreements" component={TermsAndConditionsConfig} />
              <PrivateRoute path="/settings" component={Settings} />
              <PrivateRoute path="/admin" component={AdminPage} />
              <PrivateRoute path="/customers/request-access/bulk-edit" component={MassEditRequestAccess} />
              <PrivateRoute path="/customers/request-access" component={RequestAccessList} />
              <PrivateRoute path="/customers/import" component={CustomersImport} />
              <PrivateRoute path="/customers/list" component={Customers} />
              <PrivateRoute path="/customers/:id/balance" component={CustomerRewardBalanceForm} />
              <PrivateRoute path="/customers/:id/edit" component={CustomerForm} />
              <PrivateRoute path="/customers/:id/:tab" component={Customer} />
              <PrivateRoute path="/customers/create" component={CustomerForm} />
              <PrivateRoute path="/subscriptions/edit/:id/:incrementId" component={EditSubscription} />
              <PrivateRoute path="/subscriptions" component={Subscriptions} />
              <PrivateRoute path="/gift-cards/create-gift-code" component={CreateGiftCode} />
              <PrivateRoute path="/gift-cards/:giftcardId" component={EditGiftCode} />
              <PrivateRoute path="/gift-cards" component={GiftCards} />
              <PrivateRoute path="/analytics" component={Analytics} />
              <PrivateRoute path="/help/:categoryUrl?/:subCategoryUrl?/:topicUrl?" component={Help} />
              <PrivateRoute path="/buildyourstore/:activeStep?" component={Steps} />
              <PrivateRoute path="/safari-notification" component={UnsupportedBrowserNotification} />
              <PrivateRoute path="/" component={Home} />
            </Switch>
          </ThemeSuspense>
        </Router>
        <PopUpNotifications />
      </Theme>
    </SettingsProvider>
  );

  function PrivateRoute({ component: Component, path, allowedStores, ...rest }: IPrivateRouteProps) {
    const { profile, userStoreData, userPermissions, isRefreshingToken } = useSelector((state: IReduxState) => state.user);
    const dispatch = useDispatch();
    const token = Cookies.get('token');
    const refreshToken = Cookies.get('refresh');
    const isBuildUrl = rest.location.pathname.includes('buildyourstore');
    // const isMarketingUrl = rest.location.pathname.replace(/\//, '') === 'marketing';

    const permissionRequired = pathPermissions[path];
    const storeType: AllowedStoreType = userStoreData?.storeType;
    const activeStore = profile?.stores?.[0];
    const activeStoreUrl = activeStore?.apiUrl;
    const isStoreLive = activeStore?.isLive && rest.location.pathname;

    const isUserHavePermissions = !(permissionRequired in userPermissions && !userPermissions[permissionRequired]);
    const isCorrectStoreType = allowedStores ? allowedStores.includes(storeType) : true;
    const isUserHaveStore = !!profile.stores?.length;
    // const marketingUrlButStoreIsLive = isStoreLive && isMarketingUrl;

    useEffect(() => {
      // Remove only this channel's own listener on cleanup. A bare socket.off() drops every
      // listener on the socket, including run scoped ones registered by a page - and React runs
      // child effects before parent ones, so a page listener would be wiped right after it was
      // added. Same single listener per active store as before, just cleaned up precisely.
      const handleStoreEvent = (data) => {
        //TODO: make ability to scale queue to diff type of tasks
        const isCustomerQueueAction = data.action.includes('CUSTOMER_IMPORT');
        const patientGroupQueueActions = ['QUOTE_TASK_ADDED', 'QUOTE_TASK_REMOVED', 'QUOTE_TASK_UPDATED', 'QUOTE_TASK_COMPLETED'];
        const isPatientGroupQueueAction = patientGroupQueueActions.includes(data?.action);

        if (isCustomerQueueAction) {
          dispatch(receiveCustomersImportQueueTaskUpdate(data));
        } else if (isPatientGroupQueueAction) {
          dispatch(receiveMarketingSegmentQuoteQueueTaskUpdate(data));
        } else {
          dispatch(receiveQueuedTaskUpdate(data));
        }
      };

      socket.on(activeStoreUrl, handleStoreEvent);

      return () => {
        socket.off(activeStoreUrl, handleStoreEvent);
      };
    }, [socket, activeStoreUrl]);

    useEffect(() => {
      if (!token && refreshToken) {
        refreshUserTokenAPI({dispatch});
      } else if (token && !profile.email) {
        getUserProfileAPI({dispatch});
      }
    }, [token, profile.email]);

    return (
      <Route
        {...rest}
        render={(props) => {
          if (!token) {
            if (refreshToken || isRefreshingToken) {
              return <Loading />;
            }

            return (<Redirect to="/login" />);
          }

          if (token && !profile.email) {
            return <Loading />;
          }

          if (profile.email && !isUserHaveStore) {
            return (
              isBuildUrl ?
                <Layout>
                  <Steps />
                </Layout>
                :
                <Redirect to="/buildyourstore" />
            );
          }

          if (!isUserHavePermissions || !isCorrectStoreType || (isUserHaveStore && isBuildUrl)) {
            return <Redirect to="/" />;
          }

          if (isSafari && Number(browserVersion) < 15) {
            return (
              <Layout>
                <UnsupportedBrowserNotification />
              </Layout>
            );
          }

          if (isChrome && Number(browserVersion) < 86) {
            return (
              <Layout>
                <UnsupportedChromeNotification />
              </Layout>
            );
          }

          if (isStoreLive && (props.location.hash === '#go_live_requirements'
            || (props.location.pathname === '/settings' && props.location.hash === '')
          )) {
            return <Redirect to="/settings#UI_configurations" />;
          }

          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }
        }
      />
    );
  }
};

export default App;
